import React from 'react';
import { Card } from '@avila-tek/ui/src';
import { Alert } from '../shared';
import { Option, Variant } from '../../models';
import OptionForm from './option/OptionForm';
import VariantForm from './VariantForm';

interface VariantsFormProps {
  updateOptions: React.Dispatch<React.SetStateAction<Option[]>>;
  updateVariants: React.Dispatch<React.SetStateAction<Variant[]>>;
  variants: Variant[];
}

function VariantsForm({
  variants,
  updateOptions,
  updateVariants,
}: VariantsFormProps) {
  const _variants = React.useMemo(
    () => variants.filter((variant) => variant.active),
    [variants]
  );

  return (
    <>
      <Card className="overflow-x-auto  mt-10">
        <Card.Header>Variantes</Card.Header>
        <Card.Body>
          {variants.length === 0 ? (
            <Alert
              title="Variantes"
              text="Crea las variantes del producto. Estas están compuestas por las características del producto"
              show
            />
          ) : null}
          <OptionForm updateOptions={updateOptions} />
        </Card.Body>
      </Card>
      {_variants.map((variant) => (
        <Card className="overflow-x-auto mt-10">
          <VariantForm
            key={variant._id}
            _id={variant._id}
            updateVariants={updateVariants}
            option1={variant?.option?.option1 ?? ''}
            option2={variant?.option?.option2 ?? ''}
            option3={variant?.option?.option3 ?? ''}
          />
        </Card>
      ))}
    </>
  );
}

export default VariantsForm;
